/**
 * 全站搜尋的純函式：Header 初步結果分區、結果頁篩選器切換
 */

import type { ISearchItem } from '@/assets/types/api/Search';

interface ISearchGroups {
  products: ISearchItem[];
  industryFocuses: ISearchItem[];
  caseStudies: ISearchItem[];
  results: ISearchItem[];
}

/**
 * 依 `type` 將前 16 筆結果歸入各區塊，各區塊取上限筆數；其餘歸入 Search Results
 *
 * @param items: API 回傳的結果
 * @param isMobile: 手機版 Products / Search Results 上限為 3，其餘為 5
 */
export function provideSearchGroups(
  items: ISearchItem[],
  isMobile: boolean
): ISearchGroups {
  const mainLimit = isMobile ? 3 : 5;
  const groups: ISearchGroups = {
    products: [],
    industryFocuses: [],
    caseStudies: [],
    results: [],
  };
  const limits = {
    products: mainLimit,
    industryFocuses: 3,
    caseStudies: 3,
    results: mainLimit,
  };

  items.forEach((item) => {
    const key: keyof ISearchGroups =
      item.type === 'products'
        ? 'products'
        : item.type === 'industryFocuses'
          ? 'industryFocuses'
          : item.type === 'caseStudies'
            ? 'caseStudies'
            : 'results';

    if (groups[key].length < limits[key]) {
      groups[key].push(item);
    }
  });

  return groups;
}

/**
 * 結果頁篩選器點擊後的選取結果；`All` 以空陣列表示
 * - 點 All：清空
 * - 點已選：取消，全部取消後回到 All
 * - 點未選：加入（可複選）
 */
export function provideToggledTypes(
  current: string[],
  clicked: string | null
): string[] {
  if (clicked === null) {
    return [];
  }
  return current.includes(clicked)
    ? current.filter((type) => type !== clicked)
    : [...current, clicked];
}
